// extracted by mini-css-extract-plugin
export default {"csfSpinnerContainer":"CsfNew-module_csfSpinnerContainer__EDWQH"};